import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, SelectInput, Arrow, Checkbox, Dropdown, LabelText, OptionLabel, SelectText } from './multi-select.styled';

// Глобальный счетчик для генерации уникальных ID в рамках одной страницы (подход для React 17)
let instancesCounter = 0;

export const MultiSelect = (props) => {
  const { name, options = [], value = [], onChange, placeholder = 'Выберите варианты...', width } = props;
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  // Генерируем уникальный префикс для ID при первом рендере компонента
  const componentIdRef = useRef(null);
  if (componentIdRef.current === null) {
    instancesCounter += 1;
    componentIdRef.current = `multiselect-${instancesCounter}`;
  }

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  // Обработка клика/изменения чекбокса
  const handleCheckboxChange = (optionValue) => {
    if (!onChange) {
      return;
    }

    const newValue = value.includes(optionValue) ? value.filter((item) => item !== optionValue) : [...value, optionValue];

    onChange({ target: { name, value: newValue } });
  };

  // Закрытие по клику вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // all checked
  const isAllChecked = value.length === options.length;

  /**
   * toggle all options state
   */
  const handleToggleAll = () => {
    if (!onChange) {
      return;
    }

    if (isAllChecked) {
      // clear selection
      onChange({ target: { name, value: [] } });
    } else {
      onChange({ target: { name, value: options.map((el) => el.value) } });
    }
  };

  // Формирование строки для отображения
  const selectedText = value.join(', ');

  const hasSelection = value.length > 0;
  const idAll = `${componentIdRef.current}-all`;
  // console.log('hasSelection', options, value, selectedText);
  // console.log('options', options);
  return (
    <Container ref={containerRef} $width={width}>
      <SelectInput $isOpen={isOpen} onClick={toggleDropdown} aria-expanded={isOpen} aria-haspopup="listbox">
        <SelectText $isPlaceholder={!hasSelection}>{hasSelection ? selectedText : t('form.' + placeholder)}</SelectText>
        <Arrow $isOpen={isOpen} />
      </SelectInput>

      {isOpen && (
        <Dropdown>
          <OptionLabel htmlFor={idAll} $selected={isAllChecked}>
            <Checkbox id={idAll} checked={isAllChecked} onChange={() => handleToggleAll()} />
            <LabelText $selected={isAllChecked}>{t('filter.Все')}</LabelText>
          </OptionLabel>
          {options.map((option, index) => {
            // console.log("option", option);
            const isChecked = value.includes(option.value);
            // console.log("isChecked", isChecked, value, option.value);
            const optionId = `${componentIdRef.current}-${option.value}-${index}`;

            return (
              <OptionLabel key={index} htmlFor={optionId} $selected={isChecked}>
                <Checkbox id={optionId} checked={isChecked} onChange={() => handleCheckboxChange(option.value)} />
                <LabelText $selected={isChecked}>{option.label}</LabelText>
              </OptionLabel>
            );
          })}
        </Dropdown>
      )}
    </Container>
  );
};
